<table class="mc-project-checklist-table mc-grid-padded-cells" mat-table [dataSource]="parsedTableData$ | async">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef><b class="mc-project-checklist-table-header">Column</b></th>
    <td mat-cell class="mat-column-name" *matCellDef="let column">
      <div class="mc-truncate">
        <mat-icon fontSet="project-titan" fontIcon="icon-dot" [color]="column.Color" class="mc-centered-text-icon"></mat-icon>
        &nbsp;
        <span [matTooltip]="column.Legend">
          {{ column.Legend }}
        </span>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="item">
    <th mat-header-cell *matHeaderCellDef><b class="mc-project-checklist-table-header">Items</b></th>
    <td mat-cell *matCellDef="let column">
      {{column.Count}} / {{column.Total}}
    </td>
  </ng-container>
  <ng-container matColumnDef="percent">
    <th mat-header-cell *matHeaderCellDef><b class="mc-project-checklist-table-header">Complete</b></th>
    <td mat-cell *matCellDef="let column">
      {{column.Percent | number : '1.0-0'}}%
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="tableDisplayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: tableDisplayedColumns;"></tr>
</table>